import { observer } from "mobx-react";
import React, { FC, useMemo, useState } from "react";
import { UserAccountStore } from "store/UserAccounts/UserAccount/UserAccount.store";
import { ApiRequestStatusEnum } from "enums/api-request-status.enum";
import { Error, Loader } from "components";
import { ZooplaIntegrationAPIConfigurator } from "./ZooplaIntegrationAPIConfigurator";
import { ZooplaIntegrationForm } from "./ZooplaIntegrationForm";
import { OfficeInputIntegrationTable } from "../AccountIntegrationConfigurator/OfficeInputIntegrationTable";
import { AccountIntegrationTypeEnum } from "enums/account-integration-type.enum";

interface IProps {
  accountStore: UserAccountStore;
}

export const ZooplaIntegrationConfigurator: FC<IProps> = observer(
  ({ accountStore }) => {
    const [loadingStatus, setLoadingStatus] = useState(
      ApiRequestStatusEnum.NONE
    );
    const accountOfficesStore = accountStore.accountOfficesStore;
    const accountIntegrationsStore = accountStore.accountIntegrationsStore;
    const accountIntegrationZooplaStore =
      accountIntegrationsStore.accountIntegrationZooplaStore;

    useMemo(() => {
      const fetchData = async () => {
        try {
          setLoadingStatus(ApiRequestStatusEnum.PENDING);
          await Promise.all([
            accountOfficesStore.fetchAccountOffices(),
            accountIntegrationZooplaStore.fetchAccountOfficeRelations(),
          ]);
          setLoadingStatus(ApiRequestStatusEnum.SUCCESS);
        } catch (e) {
          setLoadingStatus(ApiRequestStatusEnum.ERROR);
        }
      };

      fetchData();
    }, [accountOfficesStore, accountIntegrationZooplaStore]);

    return (
      <>
        {loadingStatus === ApiRequestStatusEnum.PENDING && <Loader />}
        {loadingStatus === ApiRequestStatusEnum.ERROR && <Error />}
        {loadingStatus === ApiRequestStatusEnum.SUCCESS && (
          <>
            <ZooplaIntegrationForm
              accountIntegrationsStore={accountIntegrationsStore}
            />
            <ZooplaIntegrationAPIConfigurator
              accountIntegrationZooplaStore={accountIntegrationZooplaStore}
            />
            <OfficeInputIntegrationTable
              accountIntegrationsStore={accountIntegrationsStore}
              integrationOfficesStore={
                accountIntegrationZooplaStore.accountIntegrationOfficesStore
              }
              integrationType={AccountIntegrationTypeEnum.ZOOPLA}
            />
          </>
        )}
      </>
    );
  }
);
